import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-down-arrow",
  "use": "icon-down-arrow-usage",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-down-arrow\"><path fill-rule=\"evenodd\" d=\"M1.757 6.5c-.27 0-.342.159-.146.355l3.29 3.29a.496.496 0 0 0 .71 0l3.29-3.29c.203-.203.131-.355-.145-.355h-2L6.295.958A.5.5 0 0 0 5.796.5h-1.08a.5.5 0 0 0-.498.458L3.756 6.5Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol